import { __rest } from '../../../_virtual/_tslib.js';
import { useForkRef } from '@mui/material';
import { useRef, useMemo, useCallback } from 'react';

function useSingleInput({ inputProps, ref }) {
    const { format, value, onChange } = inputProps, rest = __rest(inputProps, ["format", "value", "onChange"]);
    const inputRef = useRef(null);
    const timeoutRef = useRef();
    const singleInputRef = useForkRef(inputRef, ref);
    const hasFocus = document.activeElement === inputRef.current;
    const placeholder = useMemo(() => format, [format]);
    const viewValue = useMemo(() => {
        if (!hasFocus && !value) {
            return "";
        }
        if (hasFocus && !value) {
            return placeholder;
        }
        return value;
    }, [hasFocus, value, placeholder]);
    const setSelection = useCallback(() => {
        const input = inputRef.current;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(() => {
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) {
                return;
            }
            input.select();
        });
    }, []);
    const handleChange = useCallback((event) => {
        event.preventDefault();
        if (!event.target.value) {
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        }
        setSelection();
    }, [onChange, setSelection]);
    return {
        singleInputProps: Object.assign(Object.assign({}, rest), { placeholder, value: viewValue, onChange: handleChange, setSelection }),
        singleInputRef,
        hasValue: viewValue !== format,
    };
}

export { useSingleInput };
//# sourceMappingURL=useSingleInput.js.map
